import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'app';
}



// WEBPACK FOOTER //
// /Users/dearmom/Sites/portfolio/src/app/app.component.ts